module.exports = __webpack_public_path__ + "img/letter-m.b0c23a9c.svg";